import { I18n } from "i18n-js";
import En from "bundles/i18n/en.json";
import Es from "bundles/i18n/es.json";

export const i18n = new I18n({
  en: En.en,
  es: Es.es,
});
